import { render } from "./SiteHeaderMc.vue?vue&type=template&id=5471c8aa"
import script from "./SiteHeaderMc.vue?vue&type=script&lang=js"
export * from "./SiteHeaderMc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__